import styled from "styled-components";

export const ModelInfoWrapper = styled.div`
  .card-text {
    color: var(--text-color-secondary, #949596);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 170%;
  }
  .card-sub-heading {
    color: var(--text-color-secondary, #949596) !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 0px;
  }
  .card-sub-text {
    color: var(--text-color, #1c1c1c);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin: 0;
  }
  .color-primary {
    margin-bottom: 5px;
  }
  .description {
    margin-top: 14px;
    margin-bottom: 5px;
  }
  .description-text {
    line-height: 170%;
    color: var(--text-color, #1c1c1c);

    p, li, td, th, strong, em {
      color: var(--text-color, #1c1c1c);
    }
    h1, h2, h3, h4, h5, h6 {
      color: var(--text-color, #1c1c1c);
    }
    a {
      color: var(--primary-color, #1677ff);
    }
    a:hover {
      color: var(--primary-color-hover, #4096ff);
    }
    blockquote {
      color: var(--text-color-secondary, #555);
      border-left: 4px solid var(--border-color, #d9d9d9);
      background-color: var(--bg-color-secondary, #f7f7f7);
      padding: 0.5em 1em;
      margin: 0.5em 0;
    }

    code:not(.hljs) {
      background-color: var(--bg-color-secondary, #f4f4f4);
      color: var(--primary-color, #c7254e);
      border: 1px solid var(--border-color-secondary, #e0e0e0);
      border-radius: 3px;
      padding: 1px 4px;
      font-size: 0.9em;
    }

    pre {
      background: transparent;
      border: none;
      padding: 0;
      margin: 0.5em 0;
    }
    pre > div {
      background-color: var(--bg-color-secondary, #fafafa) !important;
      border: 1px solid var(--border-color-secondary, #e0e0e0) !important;
    }
    pre > div > div {
      background-color: var(--bg-color, #ffffff) !important;
    }
    pre code, pre code.hljs {
      background-color: transparent !important;
      color: var(--text-color, #1c1c1c) !important;
    }
  }
`;
